
import React from "react";
import { TableCell, TableRow } from "@/components/ui/table";
import { Account, LeadAccount, StrategyWithDetails } from "@/types/strategy-types";
import AccountActions from "../AccountActions";
import AccountStatusBadge from "./AccountStatusBadge";
import PrimaryBadge from "./PrimaryBadge";
import LinkCountBadge from "./LinkCountBadge";
import { LinkCountsData } from "@/hooks/admin/accounts/useLinkCountsApi";

interface AccountTableRowProps {
  account: Account;
  getLeadAccountName: (leadAccountId: string) => string;
  getStrategyName: (strategyId: string) => string;
  onEdit: (account: Account) => void;
  onDelete: (account: Account) => void;
  onToggleActive: (id: string, active: boolean) => Promise<void>;
  userRole?: string | null;
  refreshKey: number;
  linkCounts: LinkCountsData;
  isLoading: boolean;
  error: Error | null;
  onManualRefresh: () => void;
}

const AccountTableRow = ({
  account,
  getLeadAccountName,
  getStrategyName,
  onEdit,
  onDelete,
  onToggleActive,
  userRole,
  refreshKey,
  linkCounts,
  isLoading,
  error,
  onManualRefresh
}: AccountTableRowProps) => {
  return (
    <TableRow key={`${account.id}-${refreshKey}`}>
      <TableCell className="font-medium">{account.external_id}</TableCell>
      <TableCell>{account.exchange}</TableCell>
      <TableCell>{getLeadAccountName(account.lead_account_id)}</TableCell>
      <TableCell>{getStrategyName(account.strategy_id)}</TableCell>
      <TableCell>
        <AccountStatusBadge active={account.active} />
      </TableCell>
      <TableCell>
        <PrimaryBadge isPrimary={account.is_primary} />
      </TableCell>
      <TableCell>
        <LinkCountBadge 
          accountId={account.id}
          linkCounts={linkCounts}
          isLoading={isLoading}
          error={error}
          onRefresh={onManualRefresh}
        />
      </TableCell>
      <TableCell className="text-right">
        <AccountActions
          account={account}
          onEdit={onEdit}
          onDelete={onDelete}
          onToggleActive={onToggleActive}
          userRole={userRole}
        />
      </TableCell>
    </TableRow>
  );
};

export default AccountTableRow;
